var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menus"},[_c('div',{staticStyle:{"text-indent":"10px"}},[_c('a',{class:{disabled:!_vm.props},on:{"click":function($event){return _vm.onTop()}}},[_vm._v("节点置顶")])]),_c('div',{staticStyle:{"text-indent":"10px"}},[_c('a',{class:{disabled:!_vm.props},on:{"click":function($event){return _vm.onBottom()}}},[_vm._v("节点置底")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }